import { use, useEffect, useMemo, useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

import { Link, useNavigate } from "react-router-dom";
import { Button } from "./button";
import NCloodLogoIcon from "./icons/breath-guru-logo-icon";
import UsersService from "../services/UserService";
import { useAuth } from "../context/AuthContext";
import AuthService from "../services/AuthService";
import { User } from "../models";
import  UserRole from "../enums/UserRole";
export default function AppHeader() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ctx = useAuth();
  const auth = new AuthService();
  const [loading, setLoading] = useState(true);
  const getUserProfile = async () => {
    try {
      const response = await new UsersService().getMyProfile();
      ctx.login(response.data);
      console.log("User Profile:", response.data);
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
    ctx.loaded(true);
    setLoading(false);
  };
  useEffect(() => {
    getUserProfile();
  }, []);

  const handleLogout = async () => {
    try{
      await auth.logout();

    }
    catch (error) {
      console.error("Logout failed:", error);
      return;
    }
    // Implement logout logic here
    ctx.logout();
    navigate("/");
    console.log("User logged out");
  };
  const myAccountLink= useMemo(() => {
    if(ctx.user && (ctx.user.role === UserRole.ADMIN || ctx.user.role === UserRole.SUPERADMIN)) {
      return "/admin";
    }
    return "/client";
  }, [ctx.user]);
  
  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow transition-all">
      <nav className="container mx-auto px-4 flex items-center justify-between h-16">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <NCloodLogoIcon className="h-8" />
          <span className="font-bold text-xl text-purple-700">nClood</span>
        </div>
        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8 font-medium text-purple-900">
          <li>
            <Link to="/" className="hover:text-purple-600 transition">
              Home
            </Link>
          </li>
          {/* <li>
            <Link to="/prices" className="hover:text-purple-600 transition">
              Prices
            </Link>
          </li>
          <li>
            <Link to="/contact" className="hover:text-purple-600 transition">
              Contact Us
            </Link>
          </li> */}
          {!loading ? (
            <li>
              {ctx.user && ctx.user.name ? (
                <Link to={myAccountLink} className="hover:text-purple-600 transition">
                  My Acount
                </Link>
              ) : (
                <Link to="/auth/login">
                  <Button className="ml-2 px-5 py-2 text-sm font-semibold bg-green-600 hover:bg-green-700 text-white rounded shadow">
                    Login
                  </Button>
                </Link>
              )}
            </li>
          ) : null}
          {ctx.user ? (
            <li>
              <a
                className="hover:text-purple-600 transition cursor-pointer"
                onClick={handleLogout}
              >
                Log Out
              </a>
            </li>
          ) : null}
        </ul>
        {/* Mobile Hamburger */}
        <button
          className="md:hidden p-2 rounded text-purple-700 focus:outline-none"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? (
            <XMarkIcon className="h-7 w-7" />
          ) : (
            <Bars3Icon className="h-7 w-7" />
          )}
        </button>
      </nav>
      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-white shadow-lg border-t">
          <ul className="flex flex-col items-center gap-4 py-4 font-medium text-purple-900">
            <li>
              <Link
                to="/"
                className="hover:text-purple-600 transition"
                onClick={() => setOpen(false)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/prices"
                className="hover:text-purple-600 transition"
                onClick={() => setOpen(false)}
              >
                Prices
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-purple-600 transition"
                onClick={() => setOpen(false)}
              >
                Contact Us
              </Link>
            </li>
            <li>
              {!loading ? (
            <li>
              {ctx.user && ctx.user.name ? (
                <Link to={myAccountLink} className="hover:text-purple-600 transition" onClick={() => setOpen(false)}>
                  My Acount
                </Link>
              ) : (
                <Link to="/auth/login" onClick={() => setOpen(false)}>
                  <Button className="px-5 py-2 text-sm font-semibold bg-purple-600 hover:bg-purple-700 text-white rounded shadow">
                    Login
                  </Button>
                </Link>
              )}
            </li>
          ) : null}
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
